<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="WorkLvMoney" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="18" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>作品级别分值表</span>
              <div class="base-card-operation">
                <!--
                <el-button @click="onExportClick()" type="primary" :size="defaultFormItemSize"
                  :disabled="!checkPermCodeExist('WorkLvMoney:WorkLvMoney:export')">
                  导出
                </el-button>
                -->
                <el-button @click="onAddWorkLvMoneyClick({id:0,type:'root'})" type="primary" :size="defaultFormItemSize" >
                  添加大类
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paWorkLvMoney" :data="WorkLvMoney.PaWorkLvMoney.impl.dataList" :size="defaultFormItemSize" @sort-change="WorkLvMoney.PaWorkLvMoney.impl.onSortChange"
                  header-cell-class-name="table-header-gray" highlight-current-row @current-change="WorkLvMoney.PaWorkLvMoney.impl.currentRowChange"
                  row-key="id" default-expand-all height="600px" @row-click="handleRowClick"
                >
                  <el-table-column type="selection" width="55px"></el-table-column>
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="WorkLvMoney.PaWorkLvMoney.impl.getTableIndex" />
                  <el-table-column label="名称" prop="name" width="230px">
                  </el-table-column>
                  <el-table-column label="类型" prop="typeDictMap.name">
                  </el-table-column>
                  <el-table-column label="区间开始" prop="lvMin">
                  </el-table-column>
                  <el-table-column label="区间结束" prop="lvMax">
                  </el-table-column>
                  <el-table-column label="奖励金额" prop="money">
                  </el-table-column>
                  <el-table-column label="启用" prop="enableFlagDictMap.name">
                    <template slot-scope="scope">
                      <span :style="scope.row.enableFlag==='N'?'color:red;font-weight:bold':''">
                        {{scope.row.enableFlagDictMap.name}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="排序" prop="sort">
                  </el-table-column>
                  <el-table-column label="描述" prop="detail" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column label="备注" prop="remark">
                    <template slot-scope="scope">
                      <span :style="scope.row.enableFlag==='N'?'color:red;font-weight:bold':''">
                        {{scope.row.remark}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" fixed="right" width="110px">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 v-if="scope.row.type!=='root'"
                                >
                        删除
                      </el-button>
                      <el-button @click="onAddWorkLvMoneyClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 v-if="scope.row.type!=='post'"
                                >
                        添加{{scope.row.type==='root'?'类型':scope.row.type==='big_type'?'级别':scope.row.type==='type'?'比例':''}}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="6" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>编辑数据</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col :span="24">
                <EditWorkLvMoney ref="editWorkLvMoneyForm"
                  :id="(WorkLvMoney.PaWorkLvMoney.impl.currentRow || {}).id"
                  @submit="onEditWorkLvMoneyFormSubmit"
                />
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>
<style lang="scss">
.el-tooltip__popper {
  max-width: 50%;
}
</style>
<script>
/* eslint-disable-next-line */
import {findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaWorkLvMoneyController, DictionaryController } from '@/api';
import addWorkLvMoney from '@/views/WorkManage/addWorkLvMoney.vue';
import EditWorkLvMoney from '@/views/WorkManage/editWorkLvMoney.vue';

export default {
  name: 'WorkLvMoney',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    EditWorkLvMoney
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        PaWorkLvMoney: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: undefined,
          sort: undefined,
          lvMin: undefined,
          lvMax: undefined,
          money: undefined,
          lvD: undefined,
          lvE: undefined,
          lvF: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      },
      WorkLvMoney: {
        formFilter: {
        },
        formFilterCopy: {
        },
        ListDIv: {
          isInit: false
        },
        PaWorkLvMoney: {
          impl: new TableWidget(this.loadPaWorkLvMoneyWidgetData, this.loadPaWorkLvMoneyVerify, false, true, 'sort', 1)
        },
        EditLineDataDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.paWorkLvMoney.clearSelection();
      }
      this.$refs.paWorkLvMoney.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 作品级别分值数据获取函数，返回Promise
     */
    loadPaWorkLvMoneyWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params
      }
      return new Promise((resolve, reject) => {
        PaWorkLvMoneyController.list(this, params).then(res => {
          let dataList = res.data.dataList;
          for (let i = 0; i < dataList.length; i++) {
            let data = dataList[i];
            if (data.type === 'root' || data.type === 'big_type') {
              data.lvMin = data.lvMax = data.money = data.lvD = data.sort = '';
            }
          }
          dataList = treeDataTranslate(dataList, 'id', 'pid');

          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.WorkLvMoney.PaWorkLvMoney.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.WorkLvMoney.PaWorkLvMoney.impl.currentRow.id, 'id');
              this.$refs.paWorkLvMoney.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品级别分值数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaWorkLvMoneyVerify () {
      return true;
    },
    /**
     * 自定义组件作品分值数据修改提交方法
     */
    onEditWorkLvMoneyFormSubmit (code) {
      if (code) {
        // 自定义组件提交后刷新当前fragment，如果不需要刷新数据，请在这里修改这里
        this.refreshWorkLvMoney();
      }
    },
    /**
     * 更新作品级别分值表
     */
    refreshListDIvWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.WorkLvMoney.PaWorkLvMoney.impl.refreshTable(true, 1);
      } else {
        this.WorkLvMoney.PaWorkLvMoney.impl.refreshTable();
      }
      this.WorkLvMoney.ListDIv.isInit = true;
    },
    /**
     * 更新作品级别分值表
     */
    refreshWorkLvMoney (reloadData = false) {
      if (reloadData) this.$refs.editWorkLvMoneyForm.onResume();
      if (reloadData) {
        this.WorkLvMoney.PaWorkLvMoney.impl.refreshTable(true, 1);
      } else {
        this.WorkLvMoney.PaWorkLvMoney.impl.refreshTable();
      }
      if (!this.WorkLvMoney.isInit) {
        // 初始化下拉数据
      }
      this.WorkLvMoney.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {};

      PaWorkLvMoneyController.export(this, params, '作品级别分值.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      if (row.pid === -1) {
        this.$message.error('删除失败!根节点不能删除!');
        return;
      }
      if (row.children !== undefined && row.children.length > 0) {
        this.$message.error('删除失败!请先删除子项!');
        return;
      }
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaWorkLvMoneyController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.WorkLvMoney.PaWorkLvMoney.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 添加
     */
    onAddWorkLvMoneyClick (row) {
      row = (row || this.WorkLvMoney.PaWorkLvMoney.impl.currentRow || {});
      let params = {
        pid: row.id,
        type: row.type
      };

      this.$dialog.show('添加', addWorkLvMoney, {
        area: '400px'
      }, params).then(res => {
        this.refreshListDIvWidget();
      }).catch(e => {});
    },
    onResume () {
      this.refreshWorkLvMoney(true);
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaWorkLvMoney: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: undefined,
          sort: undefined,
          lvMin: undefined,
          lvMax: undefined,
          money: undefined,
          lvD: undefined,
          lvE: undefined,
          lvF: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshWorkLvMoney();
    }
  },
  computed: {
    addWorkLvMoneyEnabled () {
      return this.WorkLvMoney.PaWorkLvMoney.impl.currentRow != null && this.WorkLvMoney.PaWorkLvMoney.impl.currentRow != null;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
    // 作品级别分值选择行数据变化
    'WorkLvMoney.PaWorkLvMoney.impl.currentRow': {
      handler (newValue) {
      },
      immediate: true
    }
  }
}
</script>
